import React from 'react';

import { needsConfirmation, type BookingFailure } from './bookingGuard';
import styles from './styles.module.css';

interface BookActionsProps {
  canBook: boolean;
  pending: boolean;
  failure: BookingFailure | null;
  onBook: (confirmDuplicate: boolean) => void;
  onClose: () => void;
}

const BookActions: React.FC<BookActionsProps> = ({
  canBook,
  pending,
  failure,
  onBook,
  onClose,
}) => (
  <div className={styles.actionsBlock}>
    <button
      type='button'
      className={styles.primaryAction}
      onClick={() => onBook(false)}
      disabled={!canBook || pending}
    >
      Book &amp; Generate Label
    </button>
    {failure && needsConfirmation(failure) && (
      <button
        type='button'
        className={styles.secondaryAction}
        onClick={() => onBook(true)}
        disabled={pending}
      >
        Book anyway
      </button>
    )}
    <button type='button' className={styles.linkAction} onClick={onClose}>
      Cancel
    </button>
  </div>
);

export default BookActions;
